<div style="margin-bottom: 3rem" *ngIf="(searchResult?.TotalCount ?? 0) > 0">
  <h3 id="mySalesOpps">{{ 'dashboard.sales-opportunities.label' | translate | titlecase }}</h3>
</div>
<wl-card>
  <div class="atlas-table" *ngIf="(searchResult?.TotalCount ?? 0) > 0">
    <p-table [showGridlines]="true"
      #mySalesOpps
      [lazy]="true"
      [rows]="10"
      [value]="searchResult?.Result"
      [paginator]="true"
      (onLazyLoad)="lazyLoadSalesOpportunities($event)"
      [totalRecords]="searchResult?.TotalCount"
      [hidden]="!searchResult?.Result?.length"
      styleClass="wl-responsive-prime-datatable-borderless"
    >
      <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
        <SortAltIcon *ngIf="sortOrder === 0">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
        </SortAltIcon>
        <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
        </SortAmountUpAltIcon>
        <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
        </SortAmountDownIcon>
      </ng-template>
      <ng-template pTemplate="header">
        <tr class="wl-prime-datatable-hidden-phone">
          <th pSortableColumn="ProfileID" style="width: 26%">
            {{ 'dashboard.sales-opportunities.profile' | translate | titlecase }}
            <p-sortIcon field="ProfileID"></p-sortIcon>
          </th>
          <th pSortableColumn="ItemNum" style="width: 22%">
            {{ 'dashboard.sales-opportunities.revenue-item' | translate | titlecase }}
            <p-sortIcon field="ItemNum"></p-sortIcon>
          </th>
          <th pSortableColumn="Probability" style="width: 11%">
            {{ 'dashboard.sales-opportunities.probability' | translate | titlecase }}
            <p-sortIcon field="Probability"></p-sortIcon>
          </th>
          <th pSortableColumn="EstimatedAmount" style="width: 9%">
            {{ 'dashboard.sales-opportunities.amount' | translate | titlecase }}
            <p-sortIcon field="EstimatedAmount"></p-sortIcon>
          </th>
          <th pSortableColumn="EsitmatedClose" style="width: 13%">
            {{ 'dashboard.sales-opportunities.estimated-close' | translate | titlecase }}
            <p-sortIcon field="EsitmatedClose"></p-sortIcon>
          </th>
          <th pSortableColumn="LastContactDate" style="width: 12%">
            {{ 'dashboard.sales-opportunities.last-contacted' | translate | titlecase }}
            <p-sortIcon field="LastContactDate"></p-sortIcon>
          </th>
          <th style="width: 9%"></th>
        </tr>
        <tr class="wl-prime-datatable-hidden-tablet-and-bigger">
          <th pSortableColumn="EsitmatedClose" style="width: 13%">
            <p-sortIcon field="EsitmatedClose"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-opp>
        <tr class="sales-opps-grid-body wl-prime-datatable-hidden-phone">
          <td>
            <a [routerLink]="'/profile/' + opp.ProfileID">{{ opp.Profile?.ReportName }} ({{ opp.ProfileID }})</a>
          </td>
          <td>{{ opp.RevenueItem?.ItemName }}</td>
          <td>{{ opp.Probability }}</td>
          <td>{{ opp.EstimatedAmount | currency }}</td>
          <td>{{ opp.EsitmatedClose | date: 'M/d/yyyy' }}</td>
          <td>{{ opp.LastContactDate | date: 'M/d/yyyy' }}</td>
          <td class="atlas-sales-opp-dashboard-actions" style="padding: 0; text-align: center">
            <action-button
              [label]="'dashboard.sales-opportunities.actions.label' | translate | uppercase"
              [items]="actionItemsForSalesOpp(opp)"
            >
            </action-button>
          </td>
        </tr>
        <tr class="sales-opps-grid-body wl-prime-datatable-hidden-tablet-and-bigger">
          <td>
            <div class="mct-grid mct-cols-1-2">
              <div class="f-wb t-al">{{ 'dashboard.sales-opportunities.profile' | translate | titlecase }}</div>
              <div class="t-al">
                <a [routerLink]="'/profile/' + opp.ProfileID">{{ opp.Profile?.ReportName }} ({{ opp.ProfileID }})</a>
              </div>
              <div class="f-wb t-al">{{ 'dashboard.sales-opportunities.revenue-item' | translate | titlecase }}</div>
              <div class="t-al">{{ opp.RevenueItem?.ItemName }}</div>
              <div class="f-wb t-al">{{ 'dashboard.sales-opportunities.probability' | translate | titlecase }}</div>
              <div class="t-al">{{ opp.Probability | atlasPercent }}</div>
              <div class="f-wb t-al">{{ 'dashboard.sales-opportunities.amount' | translate | titlecase }}</div>
              <div class="t-al">{{ opp.EstimatedAmount | currency }}</div>
              <div class="f-wb t-al">{{ 'dashboard.sales-opportunities.estimated-close' | translate | titlecase }}</div>
              <div class="t-al">{{ opp.EsitmatedClose | date: 'M/d/yyyy' }}</div>
              <div class="f-wb t-al">{{ 'dashboard.sales-opportunities.last-contacted' | translate | titlecase }}</div>
              <div class="t-al">{{ opp.LastContactDate | date: 'M/d/yyyy' }}</div>
            </div>
            <div class="atlas-sales-opp-dashboard-actions" style="padding: 0; text-align: center">
              <action-button
                [label]="'dashboard.sales-opportunities.actions.label' | translate | uppercase"
                [items]="actionItemsForSalesOpp(opp)"
              >
              </action-button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <p-progressSpinner *ngIf="loading"></p-progressSpinner>
    <div style="margin-top: -3.3em; float: left">
      <p-select [options]="pageSizeOptions" [(ngModel)]="selectedPageSize" (ngModelChange)="handlePageSizeChange($event)" appendTo="body">
      </p-select>
    </div>
  </div>
</wl-card>

<wl-sales-opportunity-edit-dialog #salesOppEditDialog></wl-sales-opportunity-edit-dialog>
<wl-profile-contact-edit (submitClicked)="contactSubmitClicked($event)"></wl-profile-contact-edit>
<p-confirmDialog #deleteSalesOppCD key="deleteSalesOppCD">
  <ng-template pTemplate="footer">
    <button pButton type="button" (click)="deleteSalesOppCD.reject()" class="atlas-btn atlas-btn-secondary mr-10">{{ rejectText }}</button>
    <button pButton type="button" (click)="deleteSalesOppCD.accept()" class="atlas-btn atlas-btn-primary">{{ acceptText }}</button>
  </ng-template>
</p-confirmDialog>
